<div class="w-full flex justify-center px-2">
  @if (isCollapsed) {
    <div class="flex flex-col items-center justify-center w-full">
      <button
        matIconButton
        (click)="onItemClick()"
        class="w-18.75!"
        [ngClass]="
          isItemActive() ? 'bg-secondary-container!' : 'bg-transparent!'
        "
        [matTooltip]="item?.title | translate"
        [attr.aria-labelledby]="labelId"
      >
        <mat-icon
          [svgIcon]="item?.svgIcon || ''"
          [fontIcon]="!item?.svgIcon ? item?.icon : undefined"
          [ngClass]="{ 'material-icons-outlined': !isItemActive() }"
        ></mat-icon>
      </button>

      <span
        [id]="labelId"
        class="text-xs font-normal text-center mt-1 w-full px-1 text-on-secondary-container"
      >
        {{ item?.title | translate }}
      </span>
    </div>
  } @else {
    <div class="mb-2 w-full">
      <a
        tabindex="0"
        matButton
        [attr.aria-labelledby]="labelId"
        (click)="onItemClick()"
        (keydown.enter)="onItemClick()"
        class="w-full! h-auto! py-3! px-4! flex! items-center! justify-start! rounded-xl! transition-all gap-3"
        [ngClass]="
          isItemActive() ? 'bg-secondary-container!' : 'bg-transparent!'
        "
      >
        <mat-icon
          [svgIcon]="item?.svgIcon || ''"
          [fontIcon]="!item?.svgIcon ? item?.icon : undefined"
          [ngClass]="{ 'material-icons-outlined': !isItemActive() }"
          class="m-0! text-on-secondary-container!"
        ></mat-icon>

        <span
          [id]="labelId"
          class="text-sm font-normal tracking-tight text-on-secondary-container flex-1 text-left"
        >
          {{ item?.title | translate }}
        </span>
      </a>
    </div>
  }
</div>
